import BankOutlined from '@ant-design/icons/BankOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import TeamOutlined from '@ant-design/icons/TeamOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { useHistory } from 'react-router-dom'
import { blue, redPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE } from '../../../constants'
import { SelectList } from '../InternalDocumentOutgoingDocCreatePage/InternalDocumentOutgoingDocCreatePageStyled'
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'
import {
  getBoardTypeByTab,
  getPlykSuffixByTab,
  toStorageDocumentNumberByTab,
} from './feedbackBoardType'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'
import { AddCircleOutlineIcon } from '../../../components/AppIcon'

const { Dragger } = Upload
const { RangePicker } = DatePicker

const FeedbackBoardCreate = ({
  handleCancel,
  isVisible,
  isCreate = false,
  selectPeopleStore,
  fileStore,
  FeedbackProcedureStore,
  fetchFeedback,
  setIsVisible,
  feedbackTab,
}) => {
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    allDataGroupList,
  } = selectPeopleStore
  const [form] = Form.useForm()
  const OPINION_REF = useRef()
  const BASIS_REF = useRef()
  const PURPOSE_REF = useRef()
  const ATTACHED_REF = useRef()
  const OTHER_REF = useRef()
  const otherContentRefs = useRef([])
  const history = useHistory()
  const [fileList, setFileList] = useState([])
  const [expailFile, setExpailFile] = useState([])
  const [fileId, setFileId] = useState()
  const [followerList, setFollowerList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [opinionContent, setOpinionContent] = useState(null)
  const [basis, setBasis] = useState(null)
  const [purpose, setPurpose] = useState(null)
  const [attachedDocs, setAttachedDocs] = useState(null)
  const [otherContent, setOtherContent] = useState(null)
  const [editorContent, setEditorContent] = useState({
    opinionContent,
    basis,
    purpose,
    attachedDocs,
    otherContent,
  })
  const [otherContentList, setOtherContentList] = useState([
    { id: 1, content: null },
  ])

  useEffect(() => {
    ;(async () => {
      await selectPeopleStore.clearSelectUserData()
      await setFollowerList([])
      await setHandlerList([])
      await setCombinerList([])
      await selectPeopleStore.clearSelected()
    })()
  }, [])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const onFinish = useCallback(
    async values => {
      const { startDate, endDate } = values
      const otherContentData = otherContentRefs.current.map(ref => ({
        id: ref.id,
        content: ref.ref ? ref.ref.editor.getData() : '',
      }))
      setIsSubmitting(true)
      try {
        // Filter and prepare the file list
        const uploadFileList = fileList
          ? fileList
              .filter(
                (elem, index, fileList) =>
                  fileList.findIndex(file => file.name === elem.name) === index
              )
              .map(file => file.originFileObj)
              .filter(file => file)
          : []

        // Prepare for batch uploading files
        const batchUploadArr = []
        uploadFileList.forEach(file => {
          const formData = new FormData()
          formData.append('file', file)
          batchUploadArr.push(fileStore.uploadFile(formData))
        })

        // Gather handler and manager data
        const handlerData = handlerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))

        const managerData = followerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: 'VIEW',
        }))

        const combinerData = combinerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))
        if (endDate.isBefore(startDate)) {
          return message.info('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
        }

        // Validation checks
        if (managerData.length === 0) {
          return message.info(
            'Bạn chưa chọn Người lấy Ý kiến của Ban KS/Ban KTNB!'
          )
        }
        if (handlerData.length === 0) {
          return message.info('Bạn chưa chọn người xử lý !')
        }

        // Handle file uploads (await all uploads to finish)
        const uploadResponses = await Promise.all(batchUploadArr)

        // Collect all file IDs from upload responses
        const fileIds = uploadResponses.map(response => response.data.file_id)

        const submitData = {
          title: values.title,
          boardType: getBoardTypeByTab(feedbackTab),
          documentNumber: toStorageDocumentNumberByTab(
            values.documentNumber,
            feedbackTab
          ),
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          legalBasis: BASIS_REF?.current?.editor.getData(),
          purpose: PURPOSE_REF?.current?.editor.getData(),
          attachedDocuments: ATTACHED_REF?.current?.editor.getData(),
          otherContent: OTHER_REF?.current?.editor.getData(),
          content: values.content,
          feedbackComments: otherContentData
            .filter(item => item.content !== '')
            .map(item => ({ content: item.content })),
          fileIdAttachment: fileIds,
          isTTr: values.isTTr || false,
          assignees: [...handlerData, ...managerData, ...combinerData],
        }

        // Make API call to submit the form data
        const response = await FeedbackProcedureStore.createElectronicDocument(
          submitData
        )
        // Handle success or error messages
        if (response.status === 200) {
          setIsVisible(false)
          message.success('Tạo phiếu lấy ý kiến thành công')
          form.resetFields()

          setOpinionContent(null)
          setBasis(null)
          setAttachedDocs(null)
          setOtherContent(null)
          setFileList([])
          setFollowerList([])
          setHandlerList([])
          setCombinerList([])
          selectPeopleStore.clearSelectUserData()
          selectPeopleStore.clearSelectDepartmentData()
          selectPeopleStore.clearSelectedHandlerAndFollower()
          fetchFeedback()
        } else {
          console.error('Error in form submission:', response)
        }
      } catch (error) {
        console.error('Error in form submission:', error)
      } finally {
        setIsSubmitting(false)
      }
    },
    [fileList, handlerList, followerList, form, fetchFeedback, feedbackTab]
  )

  const handleEditorChange = useCallback((field, content) => {
    setEditorContent(prevState => ({
      ...prevState,
      [field]: content, // Cập nhật giá trị cho field tương ứng
    }))
  }, [])

  const handleChangeFile = useCallback(
    info => {
      if (info.fileList.length === 0) {
        form.setFieldsValue({
          file_upload: undefined,
        })
        setFileList([])
        return
      }
      const filteredFileList = info.fileList.filter(
        (elem, index, fileList) =>
          fileList.findIndex(file => file.name === elem.name) === index
      )
      setFileList(filteredFileList)
    },
    [form]
  )

  const handleChangeExplainFile = useCallback(
    info => {
      if (info.fileList.length === 0) {
        form.setFieldsValue({
          file_upload: undefined,
        })
        setExpailFile([])
        return
      }
      const filteredFileList = info.fileList.filter(
        (elem, index, fileList) =>
          fileList.findIndex(file => file.name === elem.name) === index
      )
      setExpailFile(filteredFileList)
    },
    [form]
  )

  const handleOtherContentChange = useCallback((id, content) => {
    setOtherContentList(prevList =>
      prevList.map(item => (item.id === id ? { ...item, content } : item))
    )
  }, [])

  const handleAddOtherContent = useCallback(() => {
    const newContent = { id: Date.now(), content: '' }
    setOtherContentList(prevList => [...prevList, newContent])
  }, [])

  const handleRemoveOtherContent = useCallback(id => {
    setOtherContentList(prevList => {
      const updatedList = prevList.filter(item => item.id !== id)
      return updatedList
    })

    otherContentRefs.current = otherContentRefs.current.filter(
      ref => ref.id !== id
    )
  }, [])

  const handleCompleteReset = useCallback(() => {
    form.resetFields()

    setFileList([])
    setExpailFile([])

    setFollowerList([])
    setHandlerList([])
    setCombinerList([])
    selectPeopleStore.clearSelected()

    // setBasis(INITIAL_BASIS)

    setAttachedDocs(null)
    setOtherContent(null)

    if (BASIS_REF.current && BASIS_REF.current.editor) {
      BASIS_REF.current.editor.setData('')
    }
    if (ATTACHED_REF.current && ATTACHED_REF.current.editor) {
      ATTACHED_REF.current.editor.setData('')
    }
    if (OTHER_REF.current && OTHER_REF.current.editor) {
      OTHER_REF.current.editor.setData('')
    }

    setOtherContentList([{ id: 1, content: '' }])

    otherContentRefs.current = []
  }, [
    form,
    setFileList,
    setExpailFile,
    setFollowerList,
    setHandlerList,
    setCombinerList,
    setOtherContentList,
    selectPeopleStore,
  ])

  const fileListItems = useMemo(() => {
    return fileList.map((file, _) => {
      return (
        <FileItem key={file.uid}>
          <span>
            <FileTextOutlined style={{ marginRight: 5 }} />
            {file.name}
          </span>
          <FileAction>
            <Tooltip title={'Xóa'}>
              <Button
                type={'text'}
                icon={<DeleteOutlined style={{ color: redPrimary }} />}
                onClick={() =>
                  setFileList(fileList.filter(el => el.uid !== file.uid))
                }
              />
            </Tooltip>
          </FileAction>
        </FileItem>
      )
    })
  }, [fileList, redPrimary])

  return (
    <>
      <Modal
        width={900}
        style={{ top: 40 }}
        title={'Tạo mới quy trình lấy ý kiến'}
        visible={isVisible}
        maskClosable={false}
        onCancel={handleCancel}
        footer={null}
        wrapClassName="custom-modal-wrapper">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Số hồ sơ"
                name="documentNumber"
                rules={[
                  { required: true, message: 'Vui lòng nhập số hồ sơ!' },
                ]}>
                <Input
                  placeholder="Nhập số hồ sơ"
                  suffix={`/${getPlykSuffixByTab(feedbackTab)}`}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}>
                <Input placeholder="Nhập tiêu đề" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label="Ngày bắt đầu"
                name="startDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày bắt đầu!' },
                ]}>
                <DatePicker
                  showTime={{ format: 'HH:mm' }}
                  format={'DD/MM/YYYY HH:mm'}
                  onSelect={value => form.setFieldsValue({ startDate: value })}
                  onChange={value => form.setFieldsValue({ startDate: value })}
                  style={{ width: '100%' }}
                  onOpenChange={open => {
                    if (open) {
                      // Chỉ ẩn nút OK, giữ lại nút "Bây giờ"
                      setTimeout(() => {
                        const okButtons = document.querySelectorAll(
                          '.ant-picker-ok'
                        )
                        okButtons.forEach(btn => {
                          btn.style.display = 'none'
                        })
                      }, 0)
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Ngày kết thúc"
                name="endDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày kết thúc!' },
                ]}>
                <DatePicker
                  showTime={{ format: 'HH:mm' }}
                  format={'DD/MM/YYYY HH:mm'}
                  onSelect={value => form.setFieldsValue({ endDate: value })}
                  onChange={value => form.setFieldsValue({ endDate: value })}
                  style={{ width: '100%' }}
                  onOpenChange={open => {
                    if (open) {
                      // Chỉ ẩn nút OK, giữ lại nút "Bây giờ"
                      setTimeout(() => {
                        const okButtons = document.querySelectorAll(
                          '.ant-picker-ok'
                        )
                        okButtons.forEach(btn => {
                          btn.style.display = 'none'
                        })
                      }, 0)
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={8}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, margin: '0 1px' }}>*</span>
                Người xử lý:
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
            <Col span={8}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, margin: '0 3px' }}>*</span>Ý
                kiến của Ban KS/Ban KTNB
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(
                        ASSIGNEE_TYPE.FOLLOWER
                      )
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {followerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
            <Col span={8}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                Người theo dõi
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(
                        ASSIGNEE_TYPE.COMBINER
                      )
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {combinerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
          </Row>

          <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
            <Tabs.TabPane tab="Nội dung lấy ý kiến" key="1" forceRender>
              <Form.Item label="Nội dung lấy ý kiến">
                {otherContentList.map((item, index) => (
                  <div
                    key={item.id}
                    style={{ position: 'relative', marginBottom: '16px' }}>
                    <RichEditor
                      EDITOR_REF={el => {
                        // Cập nhật tham chiếu vào ref
                        otherContentRefs.current[index] = {
                          id: item.id,
                          ref: el,
                        }
                      }}
                      editorContent={item.content}
                      onEditorChange={content =>
                        handleOtherContentChange(item.id, content)
                      }
                    />
                    {otherContentList.length > 1 && (
                      <Button
                        type="text"
                        icon={<DeleteOutlined style={{ color: 'red' }} />}
                        onClick={() => handleRemoveOtherContent(item.id)}
                        style={{
                          position: 'absolute',
                          top: '0',
                          right: '-27px',
                        }}
                      />
                    )}
                  </div>
                ))}
                <Button
                  type="link"
                  className="icon-btn"
                  htmlType="button"
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: blue, width: 16, height: 16 }}
                    />
                  }
                  onClick={handleAddOtherContent}>
                  Thêm nội dung ý kiến khác
                </Button>
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Căn cứ" key="2" forceRender>
              <Form.Item label="Căn cứ" name="basis">
                <RichEditor
                  EDITOR_REF={BASIS_REF}
                  editorContent={basis}
                  onEditorChange={content => setBasis(content)}
                />
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Mục đích" key="3" forceRender>
              <Form.Item label="Mục đích" name="purpose">
                <RichEditor
                  EDITOR_REF={PURPOSE_REF}
                  editorContent={purpose}
                  onEditorChange={content => setPurpose(content)}
                />
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Quá trình lấy ý kiến" key="4" forceRender>
              <Form.Item label="Quá trình lấy ý kiến" name="otherContent">
                <RichEditor
                  EDITOR_REF={OTHER_REF}
                  editorContent={otherContent}
                />
              </Form.Item>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Tài liệu đính kèm" key="5" forceRender>
              <Form.Item label={'Tài liệu đính kèm:'} name={'file'}>
                <Upload.Dragger
                  valuePropName={'fileList'}
                  fileList={fileList}
                  multiple={true}
                  beforeUpload={() => false}
                  onChange={handleChangeFile}
                  showUploadList={false}
                  className="custom-dragger-upload bg-white">
                  <DraggerUploadButton />
                </Upload.Dragger>
                <SignDocumentList>{fileListItems}</SignDocumentList>
              </Form.Item>
            </Tabs.TabPane>
          </Tabs>

          <div
            className="custom-create-page-footer-sticky"
            style={{
              justifyContent: 'flex-start',
              padding: '16px 0',
            }}>
            <Button
              htmlType="reset"
              danger
              style={{ marginRight: 'auto' }}
              onClick={handleCancel}>
              Hủy bỏ
            </Button>
            <Button htmlType="reset" onClick={handleCompleteReset}>
              Nhập lại
            </Button>
            <Button type="primary" htmlType="submit" disabled={isSubmitting}>
              Tạo mới
            </Button>
          </div>
        </Form>
      </Modal>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        disableAllDisabling={true}
      />
    </>
  )
}

export default memo(
  inject(
    'loadingAnimationStore',
    'selectPeopleStore',
    'fileStore',
    'FeedbackProcedureStore'
  )(observer(FeedbackBoardCreate))
)
